<ng-template>
  <th
    class="table__heading"
    [ngClass]="{
      'table__heading--sorted': sortable && (sortAsc || sortDesc)
    }"
    (click)="click()"
  >
    <div [ngClass]="{ 'table__heading--sortable': sortable }">
      <h5>
        <ng-content></ng-content>
      </h5>
      <div
        *ngIf="sortable"
        class="icon"
        [ngClass]="{ 'icon-ui-sort--ascend': sortAsc, 'icon-ui-sort--descend': sortDesc || !sortAsc }"
      ></div>
    </div>
  </th>
</ng-template>
